import { I18n } from "@assets/strings";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { LightArticle } from "@domain/lms/article/article";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { RoundedTextInput } from "@ui/components/inputs/textInput";
import { ClosableModal } from "@ui/modals/closableModal";

import { ClipLoader } from "react-spinners";
import { useMyFeedback } from "@domain/lms/article/hooks";

interface FeedbackModalProps extends React.HTMLAttributes<HTMLDivElement> {
	article: LightArticle;
	feedbackId?: string;
	close: () => void;
}

export const FeedbackModal: React.FC<FeedbackModalProps> = ({ close, feedbackId, article, ...htmlProps }) => {
	const [score] = useState(1);

	const [comment, setComment] = useState("");
	const { articleService } = useServices();
	const [loading, setLoading] = useState(false);
	const [onEdit, setOnEdit] = useState(false);

	if (feedbackId) {
		const { result: initialFeedback, loading: initialLoading } = useMyFeedback(article.id, feedbackId);
		useEffect(() => {
			if (initialFeedback) {
				setComment(initialFeedback?.text ?? "");
				setOnEdit(true);
				setLoading(initialLoading);
			}
		}, [initialFeedback]);
	}

	return (
		<Container title={I18n.t("article.feedback.infos")} close={close} lightTitle {...htmlProps}>
			<ArticleTitle>{article.title}</ArticleTitle>
			{loading ? (
				<ClipLoader />
			) : (
				<>
					{/*<StarPicker onMouseLeave={() => setHoverStars(null)}>*/}
					{/*	{Range(1, 6).map((n) => (*/}
					{/*		<InteractiveStar*/}
					{/*			key={n}*/}
					{/*			$isFilled={hoverStars ? hoverStars >= n : score >= n}*/}
					{/*			onMouseEnter={() => setHoverStars(n)}*/}
					{/*			onClick={() => setScore(n)}*/}
					{/*		/>*/}
					{/*	))}*/}
					{/*</StarPicker>*/}
					{/*<Secondary>{I18n.t(`article.feedback.stars.${hoverStars ?? score}`)}</Secondary>*/}
					<CommentInput
						value={comment}
						onChange={(e) => setComment(e.currentTarget.value.replace(/(\r\n|\n|\r)/gm, ""))}
						placeholder={I18n.t("article.feedback.placeholder")}
					/>
					<LoadingButton
						loading={loading}
						disabled={!comment || comment.trim().length === 0}
						onClick={async () => {
							try {
								setLoading(true);
								if (!onEdit) {
									await articleService.sendFeedback(article.id, { score, text: comment || undefined });
								} else if (feedbackId) {
									await articleService.updateFeedback(article.id, feedbackId, { score, text: comment || undefined });
								}
								close();
							} catch {
								setLoading(false);
							}
						}}
					>
						{I18n.t("validate")}
					</LoadingButton>
				</>
			)}
		</Container>
	);
};

const Container = styled(ClosableModal)`
	align-items: center;
`;

const ArticleTitle = styled.div`
	${({ theme }) => theme.textStyles.title};
	margin: 20px 0 35px;
`;

const CommentInput = styled(RoundedTextInput)`
	margin: 50px 0;
	line-height: 15px;
	font-size: 0.9375rem;
	padding: 20px 22px 19px;
	width: 100%;
	max-width: 500px;
	min-height: 130px;
`;
